import reducer from './reportsSlips.reducer';
import * as constant from './reportsSlips.constant';
import * as action from './reportsSlips.action';
import * as selector from './reportsSlips.selector';
import saga from './reportsSlips.saga';
import initialState from './reportsSlips.initialState';

export default {
  reducer,
  action,
  constant,
  selector,
  name: constant.NAME,
  saga,
  initialState,
};
